import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from "lucide-react";

function PaginationBtn({ children, disabled, ...props }) {
  return (
    <button
      type="button"
      disabled={disabled}
      className="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-transparent bg-white text-primary/50 shadow-sm ring-1 ring-primary/[0.05] transition-colors hover:border-primary/10 hover:text-primary disabled:cursor-not-allowed disabled:opacity-40 disabled:shadow-none"
      {...props}
    >
      {children}
    </button>
  );
}

export default function ListPagination({
  page,
  totalPages,
  totalItems,
  startIndex,
  endIndex,
  goToPage,
  className = "",
  alwaysShow = false,
  pageSize,
}) {
  if (totalItems === 0) return null;
  if (!alwaysShow && pageSize != null && totalItems <= pageSize) return null;

  return (
    <div
      className={`flex flex-col gap-3 border-t border-primary/[0.06] bg-gradient-to-r from-primary/[0.02] to-transparent px-4 py-3 sm:flex-row sm:items-center sm:justify-between sm:px-5 ${className}`}
    >
      <p className="text-xs text-primary/45">
        Showing <span className="font-semibold text-primary/70">{startIndex}–{endIndex}</span> of{" "}
        <span className="font-semibold text-primary/70">{totalItems}</span>
      </p>
      <div className="flex items-center gap-1">
        <PaginationBtn onClick={() => goToPage(1)} disabled={page === 1} aria-label="First page">
          <ChevronsLeft className="h-4 w-4" />
        </PaginationBtn>
        <PaginationBtn onClick={() => goToPage(page - 1)} disabled={page === 1} aria-label="Previous page">
          <ChevronLeft className="h-4 w-4" />
        </PaginationBtn>
        <span className="min-w-[4.5rem] rounded-lg bg-white px-2 py-1 text-center text-xs font-semibold tabular-nums text-primary ring-1 ring-primary/[0.06]">
          {page} / {totalPages}
        </span>
        <PaginationBtn
          onClick={() => goToPage(page + 1)}
          disabled={page === totalPages}
          aria-label="Next page"
        >
          <ChevronRight className="h-4 w-4" />
        </PaginationBtn>
        <PaginationBtn
          onClick={() => goToPage(totalPages)}
          disabled={page === totalPages}
          aria-label="Last page"
        >
          <ChevronsRight className="h-4 w-4" />
        </PaginationBtn>
      </div>
    </div>
  );
}
